.<template>
  <div class="table_four_warp">
    <el-table
      :cell-style="getRowClass"
      :header-cell-style="getRowClass"
      max-height="250"
      :data="tableData"
      style="width: 100%"
    >
      <el-table-column width="100px" label="task_id" prop="task_id">
      </el-table-column>
      <el-table-column width="180px" label="module" prop="module">
      </el-table-column>
      <el-table-column label="msg" prop="msg"> </el-table-column>
      <el-table-column width="80px" label="code" prop="code"> </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {
    console.log(this.tableData);
  },
  methods: {
    getRowClass({ row, column, rowIndex, columnIndex }) {
      return "background:#f1fbec";
    },
  },
};
</script>
<style lang="scss" scoped>
.table_four_warp {
  background: #f1fbec;
}
.table_onde_warp_content {
  white-space: pre-wrap;
}
</style>

<style  lang="scss">
.table_one_warp {
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-table__body-wrapper {
    scrollbar-width: thin;
    scrollbar-color: skyblue #eee;
  }
  .el-table__body-wrapper::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  .el-table__body-wrapper::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    background-color: skyblue;
    background-image: -webkit-linear-gradient(
      45deg,
      rgba(255, 255, 255, 0.2) 25%,
      transparent 25%,
      transparent 50%,
      rgba(255, 255, 255, 0.2) 50%,
      rgba(255, 255, 255, 0.2) 75%,
      transparent 75%,
      transparent
    );
  }
  .el-table__body-wrapper::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ededed;
    border-radius: 10px;
  }
}
</style>